



















































































import Vue from "vue";

export interface CardTableData {
  items_: Array<any>;
  items_per_page: number;
  items_number_to: number;
  items_number_from: number;
  items_non_sorted: Array<any>;
}

export default Vue.extend({
  name: "CardTable",
  components: {},
  props: {
    items: {
      type: Array,
      required: true
    },
    itemPerPageOptions: {
      type: Array,
      default: () => [10, 25, 50, 100]
    },
    itemsPerPage: {
      type: Number,
      default: 10
    },
    customFilter: {
      type: Function
    },
    searchFilter: {
      type: String
    },
    loading: {
      type: Boolean,
      default: false
    },
    sortBy: {
      type: String,
      default: undefined
    },
    sortDesc: {
      type: Boolean,
      default: undefined
    }
  },
  data(): CardTableData {
    return {
      items_: this.items,
      items_number_from: 0,
      items_number_to: this.items.length < this.itemsPerPage ? this.items.length : this.itemsPerPage,
      items_per_page: this.itemsPerPage,
      items_non_sorted: [...this.items]
    };
  },
  methods: {
    clickOnCard(item: any): void {
      this.$emit("click:card", item);
    },
    currentItems(): void {
      this.$emit("current-items", this.itemsDisplayed);
    },
    itemsPerPageChange(items_per_page: number): void {
      this.items_per_page = items_per_page === -1 ? this.items_.length : items_per_page;
    },
    nextPage(): void {
      if (this.items_number_to + this.items_per_page > this.items_.length) this.items_number_to = this.items_.length;
      else this.items_number_to += this.items_per_page;
      if (this.items_number_from + this.items_per_page < this.items_number_to)
        this.items_number_from += this.items_per_page;
    },
    previousPage(): void {
      if (this.items_number_from - this.items_per_page >= 0) {
        this.items_number_from -= this.items_per_page;
        this.items_number_to = this.items_number_from + this.items_per_page;
      } else {
        this.items_number_from = 0;
        this.items_number_to = this.items_per_page;
      }
    },
    resetPagination(): void {
      this.items_number_from = 0;
      this.items_number_to = this.items_per_page > this.items_.length ? this.items_.length : this.items_per_page;
    },
    filter(value: string): void {
      let items_filtered: Array<any> = [];
      this.items.forEach((item: any) => {
        if (this.customFilter) {
          if (this.customFilter("idk", value, item)) {
            items_filtered.push(item);
          }
        }
        this.items_ = items_filtered;
      });
    },
    sort(value: boolean | undefined): void {
      if (value !== undefined) {
        this.items_.sort((a: any, b: any) => {
          if (this.sortDesc) {
            if (a[this.sortBy] < b[this.sortBy]) return 1;
            if (a[this.sortBy] > b[this.sortBy]) return -1;
            return 0;
          } else {
            if (a[this.sortBy] < b[this.sortBy]) return -1;
            if (a[this.sortBy] > b[this.sortBy]) return 1;
            return 0;
          }
        });
      }
    }
  },
  computed: {
    itemsDisplayed(): Array<any> {
      let items_to_display: Array<any> = [];
      for (let i = this.items_number_from; i < this.items_number_to; i++) {
        if (i >= this.items_.length) break;
        items_to_display.push(this.items_[i]);
      }
      return items_to_display;
    }
  },
  watch: {
    searchFilter: {
      handler(value: string): void {
        this.filter(value);
        this.sort(this.sortDesc);
      },
      immediate: true
    },
    items_number_to: {
      handler(): void {
        this.currentItems();
      }
    },
    items_per_page: {
      handler(): void {
        this.resetPagination();
        this.$emit("pagination", { itemsPerPage: this.items_per_page });
      }
    },
    sortDesc: {
      handler(value: any): void {
        if (value === undefined) {
          this.items_ = this.items_non_sorted;
          this.filter(this.searchFilter);
        } else {
          this.sort(value);
        }
        this.resetPagination();
      },
      immediate: true
    },
    items: {
      handler(value: any): void {
        this.items_ = value;
        this.items_non_sorted = [...value];
        this.items_number_from = 0;
        this.items_number_to = this.items.length < this.itemsPerPage ? this.items.length : this.itemsPerPage;
        this.filter(this.searchFilter);
        this.sort(this.sortDesc);
      }
    }
  }
});
